import CalendarRange from '@app/state/calendar/CalendarRange';
import CalendarDay from '@app/state/calendar/CalendarDay';
import YearMonth from '@app/state/calendar/YearMonth';
import OperationSettings from '@app/model/company_hotel/settings/OperationSettings';
import CalendarCalculator from '@app/state/calendar/CalendarCalculator';
import utilities from '@util/Utilities';
import Utilities from '@util/Utilities';

export default class CalendarMonth {
    index: YearMonth;
    display: string;
    range: CalendarRange;
    days: CalendarDay[];

    public constructor(month: CalendarMonth) {
        Object.assign(this, month);
    }

    public static now(operation: OperationSettings) {
        const index = CalendarCalculator.now(operation);
        return CalendarMonth.from(CalendarCalculator.create(index.year, index.month));
    }

    public static from(month: CalendarMonth) {
        return new CalendarMonth(month);
    }

    public isInPast() {
        let now = CalendarCalculator.constructFromDate(new Date());
        return this.index.year < now.year || (this.index.year === now.year && utilities.getMonthOrdinal(this.index.month) < Utilities.getMonthOrdinal(now.month));

    }

    public getNextCalendarMonth() {
        const index = CalendarCalculator.next(this.index);
        return CalendarMonth.from(CalendarCalculator.create(index.year, index.month));
    }

    public getPreviousCalendarMonth() {
        const index = CalendarCalculator.previous(this.index);
        return CalendarMonth.from(CalendarCalculator.create(index.year, index.month));
    }

    public getCalendarMonthAt(index: YearMonth) {
        return CalendarMonth.from(CalendarCalculator.create(index.year, index.month));
    }
}
